// Render Ghost page content
import React, { useState, useEffect } from "react";
import useApi from "../../hooks/UseApi";

const Artifact = (props) => {
  const { ghost } = useApi();
  const [content, setContent] = useState({});
  useEffect(() => {
    window.scrollTo(0, 0);
    ghost(`pages/slug/${props.slug}`).then((data) => {
      setContent(data.pages[0]);
    });
  }, []);
  const artifactImg = {
    border: "1px",
    backgroundImage: "url(" + content?.feature_image + ")",
  };
  return (
    <div className="component-artifact">
      <h2>{content?.title}</h2>
      <div className="cost">{content?.custom_excerpt}</div>
      <div className="description">
        <div className="image" style={artifactImg}></div>
        <div
          className="text"
          dangerouslySetInnerHTML={{ __html: content?.html }}
        ></div>
      </div>
    </div>
  );
};
export default Artifact;
